const proAdvantages = {
    "en": [
        "With Swiset Pro you can have unlimited assets in your watchlist.",
        "With Swiset Pro you receive multiple insights of your trading activity.",
        "With Swiset Pro you can integrate unlimited broker accounts.",
        "With Swiset Pro you can import historic trades from several platforms.",
        "With Swiset Pro you can create a Trading Plan to enhance your discipline.",
        "With Swiset Pro you can create unlimited trading strategies to track them."
    ],
    "es": [
        "Con Swiset Pro podrás tener ilimitados activos en tu watchlist.",
        "Con Swiset Pro podrás recibir múltiples insights de tu actividad de trading.",
        "Con Swiset Pro podrás integrar ilimitadas cuentas de broker.",
        "Con Swiset Pro podrás importar trades históricos de diversas plataformas.",
        "Con Swiset Pro podrás crear Planes de Trading para mejorar tu disciplina.",
        "Con Swiset Pro podrás crear ilimitadas estrategias de trading para llevar su trazabilidad."
    ],
    "pt": [
        "Com o Swiset Pro, você pode ter ativos ilimitados na sua lista de observação.",
        "Com o Swiset Pro, você recebe vários insights sobre sua atividade de trading.",
        "Com o Swiset Pro, você pode integrar contas de corretora ilimitadas.",
        "Com o Swiset Pro, você pode importar operações históricas de várias plataformas.",
        "Com o Swiset Pro, você pode criar um Plano de Trading para melhorar sua disciplina.",
        "Com o Swiset Pro, você pode criar estratégias de trading ilimitadas para acompanhá-las."
    ],
    "zh": [
        "使用 Swiset Pro，您可以在自选列表中添加无限数量的资产。",
        "使用 Swiset Pro，您将获得关于交易活动的多项洞察。",
        "使用 Swiset Pro，您可以整合无限的券商账户。",
        "使用 Swiset Pro，您可以从多个平台导入历史交易记录。",
        "使用 Swiset Pro，您可以制定交易计划以提升交易纪律。",
        "使用 Swiset Pro，您可以创建无限的交易策略并进行追踪。"
    ],
    "th": [
        "ด้วย Swiset Pro คุณสามารถมีสินทรัพย์ได้ไม่จำกัดในรายการเฝ้าดูของคุณ",
        "ด้วย Swiset Pro คุณจะได้รับข้อมูลเชิงลึกหลากหลายเกี่ยวกับกิจกรรมการเทรดของคุณ",
        "ด้วย Swiset Pro คุณสามารถเชื่อมต่อบัญชีนายหน้าได้ไม่จำกัด",
        "ด้วย Swiset Pro คุณสามารถนำเข้าประวัติการเทรดจากหลายแพลตฟอร์มได้",
        "ด้วย Swiset Pro คุณสามารถสร้างแผนการเทรดเพื่อเพิ่มวินัยในการเทรดของคุณ",
        "ด้วย Swiset Pro คุณสามารถสร้างกลยุทธ์การเทรดได้ไม่จำกัดเพื่อใช้ติดตาม"
    ],
    "vi": [
        "Với Swiset Pro, bạn có thể có số lượng tài sản không giới hạn trong danh sách theo dõi.",
        "Với Swiset Pro, bạn sẽ nhận được nhiều thông tin phân tích về hoạt động giao dịch của mình.",
        "Với Swiset Pro, bạn có thể tích hợp tài khoản môi giới không giới hạn.",
        "Với Swiset Pro, bạn có thể nhập các giao dịch lịch sử từ nhiều nền tảng khác nhau.",
        "Với Swiset Pro, bạn có thể tạo Kế hoạch giao dịch để nâng cao tính kỷ luật.",
        "Với Swiset Pro, bạn có thể tạo các chiến lược giao dịch không giới hạn để theo dõi chúng."
    ],
    "ko": [
        "Swiset Pro를 사용하면 관심 목록에 무제한 자산을 추가할 수 있습니다.",
        "Swiset Pro를 사용하면 거래 활동에 대한 다양한 인사이트를 받을 수 있습니다.",
        "Swiset Pro를 사용하면 무제한 브로커 계정을 통합할 수 있습니다.",
        "Swiset Pro를 사용하면 여러 플랫폼에서 과거 거래 내역을 가져올 수 있습니다.",
        "Swiset Pro를 사용하면 거래 계획을 만들어 규율을 향상시킬 수 있습니다.",
        "Swiset Pro를 사용하면 거래 전략을 무제한으로 생성하고 추적할 수 있습니다."
    ]
};

export default proAdvantages;
